module.exports = __webpack_public_path__ + "img/send-offer-mobile-ru.44faa2ac.jpg";